import { render, staticRenderFns } from "./donut-chart.vue?vue&type=template&id=87cd122a&"
import script from "./donut-chart.vue?vue&type=script&lang=js&"
export * from "./donut-chart.vue?vue&type=script&lang=js&"
import style0 from "./donut-chart.vue?vue&type=style&index=0&id=87cd122a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports